import React, { FunctionComponent } from 'react'
import { Timeline, Heading, Text } from '@afterpaytouch/core'
import { useTranslation } from '../../../../utils/convergence'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../../../utils/responsive'

interface TimelineStep {
  label: string
  subtext?: string
}

export const NewToAfterpay: FunctionComponent = () => {
  const { t } = useTranslation(['educationIntro'])
  const { textSize, smallTextSize } = useCheckoutSizes()

  const steps: TimelineStep[] = [
    {
      label: t('newToAfterpay.steps.createProfile'),
    },
    {
      label: t('newToAfterpay.steps.applyPayIn4'),
      subtext: t('newToAfterpay.steps.applyPayIn4Subtext'),
    },
    {
      label: t('newToAfterpay.steps.applyPayMonthly'),
      subtext: t('newToAfterpay.steps.applyPayMonthlySubtext'),
    },
  ]

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <Heading size='L' renderAs='h2' className={styles.title}>
          {t('newToAfterpay.title')}
        </Heading>
        <Text size={textSize}>{t('newToAfterpay.description')}</Text>
      </div>
      <div className={styles.progressCard}>
        <Timeline kind='Vertical'>
          {steps.map((step, index) => (
            <Timeline.Item
              key={step.label}
              titleText={
                <div className={styles.timelineTitle}>
                  <Text size={textSize} bold>
                    {step.label}
                  </Text>
                  {step.subtext && (
                    <Text size={smallTextSize} color='Gray40' className={styles.timelineSubtext}>
                      {step.subtext}
                    </Text>
                  )}
                </div>
              }
              bodyText={{
                text: '',
              }}
              hideLine={index === steps.length - 1}
              highlight={index === 0}
            />
          ))}
        </Timeline>
      </div>
    </div>
  )
}
